var map = {
	"./3-star-wish-reveal-first.mp3": "de7f",
	"./3-star-wish-reveal.mp3": "b348",
	"./4-star-wish-reveal-first.mp3": "e8a0",
	"./4-star-wish-reveal.mp3": "e9e3",
	"./5-star-wish-reveal-first.mp3": "7b8f",
	"./5-star-wish-reveal.mp3": "8cac",
	"./banner-switch.mp3": "c1cc",
	"./bgm-wish.mp3": "aaa3",
	"./close-overlay.mp3": "be15",
	"./description-enter.mp3": "9a48",
	"./description-exit.mp3": "9d95",
	"./exit-dialog.mp3": "4a20",
	"./item-obtain.mp3": "9365",
	"./quest-click.mp3": "18f1",
	"./text-click.mp3": "659f",
	"./wish-button.mp3": "d4c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "69ff";